/* @ngInject */
const saleCtrl = (
  $scope,
  $$sale,
  $$axletree,
  $$piece,
  $$sterile,
  $$wagon,
  $$area,
  $$railway,
  excelLoader,
) => {
  $scope.$$sale = $$sale
  $scope.$$wagon = $$wagon
  $scope.$$axletree = $$axletree
  $scope.$$piece = $$piece
  $scope.$$sterile = $$sterile
  $scope.$$area = $$area
  $scope.$$railway = $$railway

  $scope.wagonIds = []
  $scope.axletreeIds = []
  $scope.axletrees = []

  $scope.$watch('$$sale.data.mySale', (currentValue, oldValue) => {
    if (currentValue === oldValue || !currentValue || !currentValue.wagons) return
    $scope.axletrees = []
    currentValue.wagons.forEach(wagon => {
      $scope.axletrees.push(...wagon.axletrees)
    })
  })

  $scope.generateBlWagons = (_sale, _wagonIds) => {
    excelLoader.blWagons.download(_sale, _wagonIds)
      .then((message) => { })
      .catch((error) => {
        toaster.message(error, 'red')
        console.error(error)
      })
  }

  $scope.generateBlEssieux = (_sale, _axletreeIds) => {
    excelLoader.blEssieux.download(_sale, _axletreeIds)
      .then((message) => { })
      .catch((error) => {
        toaster.message(error, 'red')
        console.error(error)
      })
  }

}
export default saleCtrl



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/scrapping/sale/sale.controller.js